import { IntegrationAccount } from "../common/types/integrationAccount";
import { backendClient } from "./backendClient";

export async function removeIntegrationAccount(
    account: IntegrationAccount,
): Promise<void> {
    await backendClient.delete(`/integration-account/${account.id}`);
}
